import { useTranslation } from 'react-i18next';
import { useSettingsStore } from '../../store/useSettingsStore';
import { useRole } from '../../hooks/useRole';
import ToppingPicker from './ToppingPicker';

function ExtraToppings() {
  const { t } = useTranslation();
  const role = useRole();
  const form = useSettingsStore((state) => state.form);
  const setForm = useSettingsStore((state) => state.setForm);

  return (
    <div className="rounded-lg border border-[color:var(--app-border)] bg-[color:var(--app-surface)] p-4">
      <div className="mb-2 flex items-center justify-between">
        <p className="text-sm font-semibold">{t('personalized.extraToppings')}</p>
        <span className="text-xs theme-muted">{t('personalized.extraHint')}</span>
      </div>
      <textarea
        className="w-full rounded-md border border-[color:var(--app-border)] bg-[color:var(--app-card)] min-h-[72px] px-3 py-2 text-sm outline-none focus:border-emerald-500/60 disabled:cursor-not-allowed disabled:opacity-40"
        value={form.customToppings}
        disabled={role === 'anonymous'}
        onChange={(e) => setForm((c) => ({ ...c, customToppings: e.target.value }))}
        placeholder={t('personalized.extraPlaceholder')}
      />
    </div>
  );
}

function PersonalizedTab() {
  const { t } = useTranslation();
  const role = useRole();
  const form = useSettingsStore((state) => state.form);
  const setForm = useSettingsStore((state) => state.setForm);

  return (
    <>
      {form.offer && (
        <div className="flex items-center justify-between rounded-lg border border-emerald-500/30 bg-emerald-500/10 px-4 py-2.5">
          <span className="text-sm theme-accent">{t('personalized.basedOn')}<strong>{form.offer}</strong></span>
          <button
            type="button"
            disabled={role === 'anonymous'}
            className="text-xs theme-muted transition hover:text-[color:var(--app-text)] disabled:cursor-not-allowed disabled:opacity-40"
            onClick={() => setForm((c) => ({ ...c, offer: '', toppings: [] }))}
          >
            {t('personalized.clear')}
          </button>
        </div>
      )}

      <ToppingPicker />

      <ExtraToppings />
    </>
  );
}

export default PersonalizedTab;